import React, { Component } from 'react'
import styled from 'styled-components'

import Logic from './logic'

import IcSun from './images/ic-day.component.svg'
import IcMoon from './images/ic-night.component.svg'
import IcResult from './images/ic-result.component.svg'
import IcElectric from './images/ic-eletricity.component.svg'
import IcGas from './images/ic-gas.component.svg'
import IcDependency from './images/ic-dependency.component.svg'
import ArrowIcon from 'containers/ProfileV2/images/ic-arrow.component.svg'
import IcInfo from './images/ic-info2.component.svg'

import Loading from 'components/Loading'
import ButtonOutlineV2 from '../ButtonOutlineV2'
import ButtonGradientV2 from '../ButtonGradientV2'
import Select from 'components/SelectV2'
import MobileModalV2 from '../MobileModalV2'
import InputV2 from '../InputV2'
import TooltipV2 from '../TooltipV2'

@Logic
export default class EditDataModalMobileV2 extends Component {
  state = {
    utilizationProfile: [
      {
        label: 'Maioritariamente Diurno',
        value: 'standard',
        icon: (
          <IconWrapper>
            <IcSun />
          </IconWrapper>
        ),
      },
      {
        label: 'Maioritariamente Noturno',
        value: 'night',
        icon: (
          <IconWrapper>
            <IcMoon />
          </IconWrapper>
        ),
      },
      {
        label: 'Tenho os dados da minha fatura',
        value: 'custom',
        icon: (
          <IconWrapper>
            <IcResult />
          </IconWrapper>
        ),
      },
    ],
    changedGasTermoEnergia: false,
    changedGasTermoFixo: false,
    changedElectricityCheia: false,
    changedElectricityPonta: false,
    changedElectricityVazio: false,
    changedElectricityTermoPotencia: false,
  }

  componentDidMount() {
    const {
      electricityPriceList,
      gasPriceList,
      prices,
      electricityAnnualBilling,
      gasAnnualBilling,
      electricityConsumptionCheia,
      electricityConsumptionVazio,
      electricityConsumptionPonta,
      electricityConsumptionSuperVazio,
      gasConsumption,
      priceListTimeCycle,
      gasStage,
    } = this.props
    const { setFormValues } = this.actions

    if (electricityPriceList) {
      setFormValues({
        electricityPonta: prices.electricity.ponta,
        electricityCheia: prices.electricity.cheia,
        electricityVazio: prices.electricity.vazio,
        electricityTermoFixo: prices.electricity.termo_fixo,
        electricityAnnualBilling: electricityAnnualBilling || 0,
        electricityMonthlyBilling: electricityAnnualBilling
          ? this.roundNumber(electricityAnnualBilling / 12)
          : 0,
      })

      if (
        electricityConsumptionCheia &&
        electricityConsumptionVazio &&
        electricityConsumptionPonta
      ) {
        if (priceListTimeCycle === 's') {
          const fullCheiaConsumption =
            Number(electricityConsumptionCheia) +
            Number(electricityConsumptionVazio) +
            Number(electricityConsumptionPonta) +
            Number(electricityConsumptionSuperVazio)
          setFormValues({
            electricityConsumeCheia: this.roundNumber(
              fullCheiaConsumption.toFixed(2) / 12
            ),
          })
        } else if (priceListTimeCycle === 'b') {
          const fullVazioConsumption =
            Number(electricityConsumptionSuperVazio) +
            Number(electricityConsumptionVazio)
          const fullCheiaPontaConsumption =
            Number(electricityConsumptionCheia) +
            Number(electricityConsumptionPonta)
          setFormValues({
            electricityConsumeCheia: this.roundNumber(
              fullCheiaPontaConsumption.toFixed(2) / 12
            ),
            electricityConsumeVazio: this.roundNumber(
              fullVazioConsumption.toFixed(2) / 12
            ),
          })
        } else {
          const fullVazioConsumption =
            Number(electricityConsumptionSuperVazio) +
            Number(electricityConsumptionVazio)
          setFormValues({
            electricityConsumeCheia: this.roundNumber(
              electricityConsumptionCheia / 12
            ),
            electricityConsumeVazio: this.roundNumber(
              fullVazioConsumption.toFixed(2) / 12
            ),
            electricityConsumePonta: this.roundNumber(
              electricityConsumptionPonta / 12
            ),
          })
        }
      }
    }

    if (gasPriceList) {
      setFormValues({
        gasTermoEnergia: prices.gas.termo_energia,
        gasTermoFixo: prices.gas.termo_fixo,
        gasAnnualBilling: gasAnnualBilling || 0,
        gasMonthlyBilling: gasAnnualBilling
          ? this.roundNumber(gasAnnualBilling / 12)
          : 0,
        gasMonthlyConsumption: gasConsumption
          ? this.roundNumber(gasConsumption / 12)
          : 0,
        stage: gasStage ? gasStage : 1,
      })
    }
  }

  updatePowerChoiceOptions = (timeCycle) => {
    const { options, fullEleTariff } = this.props
    const { setPowerChoices } = this.actions
    const { electricitySet } = fullEleTariff

    if (electricitySet && options) {
      const filteredSets = electricitySet.filter(
        ({ ciclo_horario }) => ciclo_horario === timeCycle
      )
      const filteredPowerChoiceOptions = []

      filteredSets.forEach((set) => {
        const option = options.powerChoices.find(
          (option) => option.value === set.potencia_contratada
        )
        if (option) {
          filteredPowerChoiceOptions.push(option)
        }
      })

      filteredPowerChoiceOptions.sort((a, b) => a.value - b.value)

      setPowerChoices(filteredPowerChoiceOptions)
    }
  }

  changeTimeCycle = (timeCycle) => {
    const {
      electricityConsumptionCheia,
      electricityConsumptionVazio,
      electricityConsumptionPonta,
      electricityConsumptionSuperVazio,
      fullEleTariff,
      formValues,
    } = this.props
    const { setFormValues } = this.actions
    const { electricitySet } = fullEleTariff

    //* Update power choice options to only show the sets from the chosen time cycle
    this.updatePowerChoiceOptions(timeCycle)

    //* Check if the new time cycle has a set with the same power choice if not change to the first
    const filteredSets = electricitySet.filter(
      ({ ciclo_horario }) => ciclo_horario === timeCycle
    )
    let newPowerChoice = formValues.potenciaContratada
    if (
      !filteredSets.find(
        ({ potencia_contratada }) => potencia_contratada === newPowerChoice
      )
    ) {
      newPowerChoice = filteredSets[0].potencia_contratada
    }

    //* Get the correct set
    const correctSet = electricitySet.find(
      ({ potencia_contratada, ciclo_horario }) =>
        potencia_contratada === newPowerChoice && ciclo_horario === timeCycle
    )

    if (
      electricityConsumptionCheia &&
      electricityConsumptionVazio &&
      electricityConsumptionPonta
    ) {
      const newValues = {
        ...(!this.state.changedElectricityPonta && {
          electricityPonta: correctSet.ponta,
        }),
        ...(!this.state.changedElectricityCheia && {
          electricityCheia: correctSet.cheias,
        }),
        ...(!this.state.changedElectricityVazio && {
          electricityVazio: correctSet.vazio_normal,
        }),
        ...(!this.state.changedElectricityTermoPotencia && {
          electricityTermoFixo: correctSet.potencia_contratada_preco,
        }),
        cicloHorario: timeCycle,
        potenciaContratada: newPowerChoice,
      }

      if (timeCycle === 's') {
        const fullCheiaConsumption =
          Number(electricityConsumptionCheia) +
          Number(electricityConsumptionVazio) +
          Number(electricityConsumptionPonta) +
          Number(electricityConsumptionSuperVazio)
        setFormValues({
          ...newValues,
          electricityConsumeCheia: this.roundNumber(
            fullCheiaConsumption.toFixed(2) / 12
          ),
        })
      } else if (timeCycle === 'b') {
        const fullVazioConsumption =
          Number(electricityConsumptionSuperVazio) +
          Number(electricityConsumptionVazio)
        const fullCheiaPontaConsumption =
          Number(electricityConsumptionCheia) +
          Number(electricityConsumptionPonta)
        setFormValues({
          ...newValues,
          electricityConsumeCheia: this.roundNumber(
            fullCheiaPontaConsumption.toFixed(2) / 12
          ),
          electricityConsumeVazio: this.roundNumber(
            fullVazioConsumption.toFixed(2) / 12
          ),
        })
      } else {
        const fullVazioConsumption =
          Number(electricityConsumptionSuperVazio) +
          Number(electricityConsumptionVazio)
        setFormValues({
          ...newValues,
          electricityConsumeCheia: this.roundNumber(
            electricityConsumptionCheia / 12
          ),
          electricityConsumeVazio: this.roundNumber(
            fullVazioConsumption.toFixed(2) / 12
          ),
          electricityConsumePonta: this.roundNumber(
            electricityConsumptionPonta / 12
          ),
        })
      }
    }
  }

  changeGasStage = (stage) => {
    const { fullGasTariff } = this.props
    const { setFormValues } = this.actions
    const { changedGasTermoEnergia, changedGasTermoFixo } = this.state
    const { gasSet } = fullGasTariff

    const set = gasSet.length > 0 ? gasSet[0] : []

    let updatedFormValues = {
      stage,
      ...(set &&
        !changedGasTermoEnergia && {
          gasTermoEnergia: set[`termo_energia_escalao_${stage}`],
        }),
      ...(set &&
        !changedGasTermoFixo && {
          gasTermoFixo: set[`termo_fixo_escalao_${stage}`],
        }),
    }

    setFormValues(updatedFormValues)
  }

  roundNumber = (num) => {
    if (!num) return
    return Number(num).toFixed(2)
  }

  roundNumberTo4 = (num) => {
    if (!num) return
    return Number(num).toFixed(4)
  }

  closeModal = () => {
    const { onClose } = this.props
    onClose()
  }

  handleKeyDown = (e) => {
    const { editSimulation } = this.actions
    e.stopPropagation()

    if (e.key === 'Enter') {
      editSimulation()
    }
  }

  disableSubmitButton = () => {
    const { formValues, electricityPriceList, gasPriceList } = this.props

    const isCustomProfile = formValues.consumerProfile === 'custom'

    if (!isCustomProfile) {
      if (
        (electricityPriceList && !formValues.electricityAnnualBilling) ||
        (gasPriceList && !formValues.gasAnnualBilling)
      ) {
        return true
      }
    } else if (isCustomProfile) {
      let customElectricityCondition = [
        'potenciaContratada',
        'cicloHorario',
        'electricityConsumeCheia',
      ]

      if (formValues.cicloHorario === 's') {
        customElectricityCondition = [
          ...customElectricityCondition,
          'electricityCheia',
          'electricityTermoFixo',
        ].some((field) => !formValues[field])
      } else if (formValues.cicloHorario === 'b') {
        customElectricityCondition = [
          ...customElectricityCondition,
          'electricityConsumeVazio',
          'electricityCheia',
          'electricityVazio',
          'electricityTermoFixo',
        ].some((field) => !formValues[field])
      } else if (formValues.cicloHorario === 't') {
        customElectricityCondition = [
          ...customElectricityCondition,
          'electricityConsumeVazio',
          'electricityConsumePonta',
          'electricityCheia',
          'electricityPonta',
          'electricityVazio',
          'electricityTermoFixo',
        ].some((field) => !formValues[field])
      }

      const customGasCondition = [
        'gasMonthlyConsumption',
        'gasTermoEnergia',
        'gasTermoFixo',
      ].some((field) => !formValues[field])

      if (electricityPriceList && gasPriceList) {
        return customElectricityCondition || customGasCondition
      }

      if (electricityPriceList) {
        return customElectricityCondition
      }

      if (gasPriceList) {
        return customGasCondition
      }
    }

    return false
  }

  renderStandardNightInputs = () => {
    const { formValues, electricityPriceList, gasPriceList } = this.props
    const { setFormValues } = this.actions

    return formValues.consumerProfile !== 'custom' ? (
      <StandardNight>
        <div className='titleRow'>
          <IcResult />
          <h5>Fatura de Energia Estimada com Impostos e IVA</h5>
        </div>
        {electricityPriceList && (
          <div className='section'>
            <div className='titleRow'>
              <IcElectric />
              <h5>Eletricidade</h5>
            </div>
            <InputsRow>
              <div className='iconInput'>
                <InputV2
                  style={{ flexGrow: '1' }}
                  required
                  label='Custo Mensal'
                  type='number'
                  placeholder='0'
                  suffix='€'
                  value={Number(formValues.electricityMonthlyBilling)}
                  onChange={(val) =>
                    setFormValues({
                      electricityMonthlyBilling: this.roundNumber(val),
                      electricityAnnualBilling: this.roundNumber(val * 12),
                    })
                  }
                />
                <span className='icon'>
                  <IcDependency />
                </span>
              </div>
              <InputV2
                style={{ width: '100%' }}
                label='Custo Anual'
                required
                type='number'
                suffix='€'
                placeholder='0'
                value={Number(formValues.electricityAnnualBilling)}
                onChange={(val) =>
                  setFormValues({
                    electricityMonthlyBilling: this.roundNumber(val / 12),
                    electricityAnnualBilling: this.roundNumber(val),
                  })
                }
              />
            </InputsRow>
          </div>
        )}

        {gasPriceList && (
          <div className='section'>
            <div className='titleRow gas'>
              <IcGas />
              <h5>Gás Natural</h5>
            </div>
            <InputsRow>
              <div className='iconInput'>
                <InputV2
                  style={{ flexGrow: '1' }}
                  required
                  label='Custo Mensal'
                  type='number'
                  placeholder='0'
                  suffix='€'
                  value={Number(formValues.gasMonthlyBilling)}
                  onChange={(val) =>
                    setFormValues({
                      gasMonthlyBilling: this.roundNumber(val),
                      gasAnnualBilling: this.roundNumber(val * 12),
                    })
                  }
                />
                <span className='icon'>
                  <IcDependency />
                </span>
              </div>
              <InputV2
                style={{ width: '100%' }}
                label='Custo Anual'
                required
                type='number'
                suffix='€'
                placeholder='0'
                value={Number(formValues.gasAnnualBilling)}
                onChange={(val) =>
                  setFormValues({
                    gasMonthlyBilling: this.roundNumber(val / 12),
                    gasAnnualBilling: this.roundNumber(val),
                  })
                }
              />
            </InputsRow>
          </div>
        )}
      </StandardNight>
    ) : null
  }

  renderSimpleTimeCycleElectricityInputs = () => {
    const { formValues } = this.props
    const { setFormValues } = this.actions

    return formValues.cicloHorario === 's' ? (
      <EnergyInputs>
        <InputsGroup>
          <h4>Consumo Mensal</h4>
          <CustomInputsRow>
            <InputV2
              style={{ width: '100%' }}
              required
              label='Energia'
              type='number'
              placeholder='0'
              suffix='kWh'
              value={Number(formValues.electricityConsumeCheia)}
              onChange={(val) =>
                setFormValues({
                  electricityConsumeCheia: this.roundNumber(val),
                })
              }
            />
          </CustomInputsRow>
        </InputsGroup>
        <InputsGroup>
          <h4>
            Preços (sem IVA)
            <TooltipV2
              style={{ height: '16px' }}
              content={
                <TooltipText>
                  Preços com a taxa de acesso à rede (sem IVA){' '}
                </TooltipText>
              }
              arrowLocation='topLeft'>
              <IcInfo width='16px' height='16px' />
            </TooltipV2>
          </h4>
          <CustomInputsRow>
            <InputV2
              style={{ width: '100%' }}
              required
              label='Energia'
              type='number'
              placeholder='0'
              suffix='€/kWh'
              value={Number(formValues.electricityCheia)}
              onChange={(val) => {
                this.setState({ changedElectricityCheia: true })
                setFormValues({ electricityCheia: this.roundNumberTo4(val) })
              }}
            />
            <InputV2
              style={{ width: '100%' }}
              required
              label='Termo Potência'
              type='number'
              placeholder='0'
              suffix='€/Dia'
              value={Number(formValues.electricityTermoFixo)}
              onChange={(val) => {
                this.setState({ changedElectricityTermoPotencia: true })
                setFormValues({
                  electricityTermoFixo: this.roundNumberTo4(val),
                })
              }}
            />
          </CustomInputsRow>
        </InputsGroup>
      </EnergyInputs>
    ) : null
  }

  renderBiTimeCycleElectricityInputs = () => {
    const { formValues } = this.props
    const { setFormValues } = this.actions

    return formValues.cicloHorario === 'b' ? (
      <EnergyInputs>
        <InputsGroup>
          <h4>Consumo Mensal</h4>
          <CustomInputsRow>
            <InputV2
              style={{ width: '100%' }}
              required
              label='Fora do Vazio'
              type='number'
              placeholder='0'
              suffix='kWh'
              value={Number(formValues.electricityConsumeCheia)}
              onChange={(val) =>
                setFormValues({
                  electricityConsumeCheia: this.roundNumber(val),
                })
              }
            />
            <InputV2
              style={{ width: '100%' }}
              required
              label='Vazio'
              type='number'
              placeholder='0'
              suffix='kWh'
              value={Number(formValues.electricityConsumeVazio)}
              onChange={(val) =>
                setFormValues({
                  electricityConsumeVazio: this.roundNumber(val),
                })
              }
            />
          </CustomInputsRow>
        </InputsGroup>
        <InputsGroup>
          <h4>
            Preços (sem IVA)
            <TooltipV2
              style={{ height: '16px' }}
              content={
                <TooltipText>
                  Preços com a taxa de acesso à rede (sem IVA){' '}
                </TooltipText>
              }
              arrowLocation='topLeft'>
              <IcInfo width='16px' height='16px' />
            </TooltipV2>
          </h4>
          <CustomInputsRow>
            <InputV2
              style={{ width: '100%' }}
              required
              label='Fora do Vazio'
              type='number'
              placeholder='0'
              suffix='€/kWh'
              value={Number(formValues.electricityCheia)}
              onChange={(val) => {
                this.setState({ changedElectricityCheia: true })
                setFormValues({ electricityCheia: this.roundNumberTo4(val) })
              }}
            />
            <InputV2
              style={{ width: '100%' }}
              required
              label='Vazio'
              type='number'
              placeholder='0'
              suffix='€/Dia'
              value={Number(formValues.electricityVazio)}
              onChange={(val) => {
                this.setState({ changedElectricityVazio: true })
                setFormValues({ electricityVazio: this.roundNumberTo4(val) })
              }}
            />
          </CustomInputsRow>
          <CustomInputsRow>
            <InputV2
              style={{ width: '100%' }}
              required
              label='Termo Fixo'
              type='number'
              placeholder='0'
              suffix='€/kWh'
              value={Number(formValues.electricityTermoFixo)}
              onChange={(val) => {
                this.setState({ changedElectricityTermoPotencia: true })
                setFormValues({
                  electricityTermoFixo: this.roundNumberTo4(val),
                })
              }}
            />
          </CustomInputsRow>
        </InputsGroup>
      </EnergyInputs>
    ) : null
  }

  renderTriTimeCycleElectricityInputs = () => {
    const { formValues } = this.props
    const { setFormValues } = this.actions

    return formValues.cicloHorario === 't' ? (
      <EnergyInputs>
        <InputsGroup>
          <h4>Consumo Mensal</h4>
          <CustomInputsRow>
            <InputV2
              style={{ width: '100%' }}
              required
              label='Ponta'
              type='number'
              placeholder='0'
              suffix='kWh'
              value={Number(formValues.electricityConsumePonta)}
              onChange={(val) =>
                setFormValues({
                  electricityConsumePonta: this.roundNumber(val),
                })
              }
            />
            <InputV2
              style={{ width: '100%' }}
              required
              label='Cheias'
              type='number'
              placeholder='0'
              suffix='kWh'
              value={Number(formValues.electricityConsumeCheia)}
              onChange={(val) =>
                setFormValues({
                  electricityConsumeCheia: this.roundNumber(val),
                })
              }
            />
          </CustomInputsRow>
          <CustomInputsRow>
            <InputV2
              style={{ width: '100%' }}
              required
              label='Vazio'
              type='number'
              placeholder='0'
              suffix='kWh'
              value={Number(formValues.electricityConsumeVazio)}
              onChange={(val) =>
                setFormValues({
                  electricityConsumeVazio: this.roundNumber(val),
                })
              }
            />
          </CustomInputsRow>
        </InputsGroup>
        <InputsGroup>
          <h4>
            Preços (sem IVA)
            <TooltipV2
              style={{ height: '16px' }}
              content={
                <TooltipText>
                  Preços com a taxa de acesso à rede (sem IVA){' '}
                </TooltipText>
              }
              arrowLocation='topLeft'>
              <IcInfo width='16px' height='16px' />
            </TooltipV2>
          </h4>
          <CustomInputsRow>
            <InputV2
              style={{ width: '100%' }}
              required
              label='Ponta'
              type='number'
              placeholder='0'
              suffix='€/kWh'
              value={Number(formValues.electricityPonta)}
              onChange={(val) => {
                this.setState({ changedElectricityPonta: true })
                setFormValues({ electricityPonta: this.roundNumberTo4(val) })
              }}
            />
            <InputV2
              style={{ width: '100%' }}
              required
              label='Cheias'
              type='number'
              placeholder='0'
              suffix='€/Dia'
              value={Number(formValues.electricityCheia)}
              onChange={(val) => {
                this.setState({ changedElectricityCheia: true })
                setFormValues({ electricityCheia: this.roundNumberTo4(val) })
              }}
            />
          </CustomInputsRow>
          <CustomInputsRow>
            <InputV2
              style={{ width: '100%' }}
              required
              label='Vazio'
              type='number'
              placeholder='0'
              suffix='€/kWh'
              value={Number(formValues.electricityVazio)}
              onChange={(val) => {
                this.setState({ changedElectricityVazio: true })
                setFormValues({ electricityVazio: this.roundNumberTo4(val) })
              }}
            />
            <InputV2
              style={{ width: '100%' }}
              required
              label='Termo Fixo'
              type='number'
              placeholder='0'
              suffix='€/kWh'
              value={Number(formValues.electricityTermoFixo)}
              onChange={(val) => {
                this.setState({ changedElectricityTermoPotencia: true })
                setFormValues({
                  electricityTermoFixo: this.roundNumberTo4(val),
                })
              }}
            />
          </CustomInputsRow>
        </InputsGroup>
      </EnergyInputs>
    ) : null
  }

  renderCustomInputs = () => {
    const {
      formValues,
      powerChoices,
      timeCycleChoices,
      gasStagesChoices,
      electricityPriceList,
      gasPriceList,
      fullEleTariff,
    } = this.props
    const { setFormValues } = this.actions

    const { electricitySet } = fullEleTariff

    return formValues.consumerProfile === 'custom' ? (
      <CustomContent>
        {electricityPriceList && (
          <div className='section'>
            <div className='titleRow'>
              <IcElectric />
              <h5>Eletricidade</h5>
            </div>
            <EnergyInputs>
              <CustomInputsRow>
                <WrapperSelect>
                  <InputLabel>Potência contratada</InputLabel>
                  <StyledSelect
                    items={powerChoices}
                    onChange={({ value }) => {
                      if (value !== formValues.potenciaContratada) {
                        const correctSet = electricitySet.find(
                          ({ potencia_contratada, ciclo_horario }) =>
                            potencia_contratada === value &&
                            ciclo_horario === formValues.cicloHorario
                        )
                        setFormValues({
                          potenciaContratada: value,
                          ...(!this.state.changedElectricityPonta && {
                            electricityPonta: correctSet.ponta,
                          }),
                          ...(!this.state.changedElectricityCheia && {
                            electricityCheia: correctSet.cheias,
                          }),
                          ...(!this.state.changedElectricityVazio && {
                            electricityVazio: correctSet.vazio_normal,
                          }),
                          ...(!this.state.changedElectricityTermoPotencia && {
                            electricityTermoFixo:
                              correctSet.potencia_contratada_preco,
                          }),
                        })
                      }
                    }}
                    selected={formValues.potenciaContratada}
                    arrowIcon={ArrowIcon}
                  />
                </WrapperSelect>
                <WrapperSelect>
                  <InputLabel>Tarifário</InputLabel>
                  <StyledSelect
                    items={timeCycleChoices}
                    onChange={({ value }) => {
                      if (value !== formValues.cicloHorario) {
                        this.changeTimeCycle(value)
                      }
                    }}
                    selected={formValues.cicloHorario}
                    arrowIcon={ArrowIcon}
                  />
                </WrapperSelect>
              </CustomInputsRow>
              {this.renderSimpleTimeCycleElectricityInputs()}
              {this.renderBiTimeCycleElectricityInputs()}
              {this.renderTriTimeCycleElectricityInputs()}
            </EnergyInputs>
          </div>
        )}

        {gasPriceList && (
          <div className='section'>
            <div className='titleRow gas'>
              <IcGas />
              <h5>Gás Natural</h5>
            </div>
            <EnergyInputs>
              <InputsGroup>
                <h4>Consumo Mensal</h4>
                <CustomInputsRow>
                  <WrapperSelect>
                    <InputLabel>Escalão</InputLabel>
                    <StyledSelect
                      items={gasStagesChoices}
                      onChange={({ value }) => {
                        if (value !== formValues.stage) {
                          this.changeGasStage(value)
                        }
                      }}
                      selected={formValues.stage}
                      arrowIcon={ArrowIcon}
                    />
                  </WrapperSelect>
                  <InputV2
                    style={{ width: '100%' }}
                    required
                    label='Energia'
                    type='number'
                    placeholder='0'
                    suffix='kWh'
                    value={Number(formValues.gasMonthlyConsumption)}
                    onChange={(val) =>
                      setFormValues({
                        gasMonthlyConsumption: this.roundNumber(val),
                      })
                    }
                  />
                </CustomInputsRow>
              </InputsGroup>
              <InputsGroup>
                <h4>
                  Preços (sem IVA)
                  <TooltipV2
                    style={{ height: '16px' }}
                    content={
                      <TooltipText>
                        Preços com a taxa de acesso à rede (sem IVA){' '}
                      </TooltipText>
                    }
                    arrowLocation='topLeft'>
                    <IcInfo width='16px' height='16px' />
                  </TooltipV2>
                </h4>
                <CustomInputsRow>
                  <InputV2
                    style={{ width: '100%' }}
                    required
                    label='Energia'
                    type='number'
                    placeholder='0'
                    suffix='€/kWh'
                    value={Number(formValues.gasTermoEnergia)}
                    onChange={(val) => {
                      this.setState({ changedGasTermoEnergia: true })
                      setFormValues({
                        gasTermoEnergia: this.roundNumberTo4(val),
                      })
                    }}
                  />
                  <InputV2
                    style={{ width: '100%' }}
                    required
                    label='Termo Fixo'
                    type='number'
                    placeholder='0'
                    suffix='€/Dia'
                    value={Number(formValues.gasTermoFixo)}
                    onChange={(val) => {
                      this.setState({ changedGasTermoFixo: true })
                      setFormValues({ gasTermoFixo: this.roundNumberTo4(val) })
                    }}
                  />
                </CustomInputsRow>
              </InputsGroup>
            </EnergyInputs>
          </div>
        )}
      </CustomContent>
    ) : null
  }

  renderWarningText = () => {
    const { formValues } = this.props

    return formValues.consumerProfile !== 'custom' ? (
      <TextSection>
        <p>
          Os cálculos apresentados assentam nos preços de energia do mercado
          regulado. Se quiser de acordo com o preço de energia da sua fatura,
          escolha o separador "Tenho os dados da minha fatura"
        </p>
      </TextSection>
    ) : null
  }
  renderLoading() {
    const { loading } = this.props
    return loading ? <Loading /> : null
  }

  renderForm = () => {
    const { loading, formValues, simulationCode } = this.props
    const { setFormValues, editSimulation } = this.actions

    return !loading ? (
      <Form>
        <UtilizationSection>
          <StyledSelect
            items={this.state.utilizationProfile.map((item) => item)}
            onChange={({ value }) => {
              if (value === 'standard' || value === 'night') {
                setFormValues({ consumerProfile: value })
              } else {
                this.updatePowerChoiceOptions(formValues.cicloHorario || 's')

                setFormValues({
                  consumerProfile: 'custom',
                  potenciaContratada: formValues.potenciaContratada || 3.45,
                  cicloHorario: formValues.cicloHorario || 's',
                })
              }
            }}
            selected={formValues.consumerProfile}
            arrowIcon={ArrowIcon}
          />
        </UtilizationSection>
        <InvoiceSection>
          {this.renderStandardNightInputs()}
          {this.renderCustomInputs()}
        </InvoiceSection>
        {this.renderWarningText()}
        <BtnsWrapper>
          <ButtonOutlineV2 onClick={() => this.closeModal()}>
            Cancelar
          </ButtonOutlineV2>
          <ButtonGradientV2
            onClick={(e) => {
              e.preventDefault()
              editSimulation(simulationCode)
            }}
            disabled={this.disableSubmitButton()}>
            Atualizar dados
          </ButtonGradientV2>
        </BtnsWrapper>
      </Form>
    ) : null
  }

  render() {
    return (
      <MobileModalV2
        setModalTriggerHeight={this.props.setModalTriggerHeight}
        modalTriggerHeight={this.props.modalTriggerHeight}
        title='Ajustar Valores'
        onClose={() => this.closeModal()}
        onKeyDown={this.handleKeyDown}
        tabIndex={-1}>
        {this.renderLoading()}
        {this.renderForm()}
      </MobileModalV2>
    )
  }
}

const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  width: 100%;
  height: 100%;
`

const TooltipText = styled.h6`
  color: #fff;
  font-family: Nunito;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 150% */
  min-width: 250px;
  margin: 0;
`

const TextSection = styled.div`
  display: flex;
  padding: 0 16px;
  align-items: flex-start;

  > p {
    color: #3e3e3e;
    font-family: Nunito;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px; /* 150% */
    max-width: unset;
    margin-bottom: 6px;
  }
`

const UtilizationSection = styled.div`
  display: flex;
  padding: 2px 20px 20px 20px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
  border-bottom: 1px solid #ececec;

  h4 {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    color: #1d1e22;
    font-feature-settings: 'liga' off, 'clig' off;
    text-overflow: ellipsis;
    font-family: Nunito;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px;
    margin: 0;
    text-transform: none;
  }

  > .inputs {
    display: flex;
    align-items: center;
    gap: 12px;
    align-self: stretch;
  }
`

const IconWrapper = styled.div`
  width: 20px;
  height: 20px;

  > svg {
    width: 100%;
    height: 100%;
    fill: #3e3e3e;

    > path {
      fill: #3e3e3e;
    }
  }
`

const InvoiceSection = styled.div`
  display: flex;
  padding: 16px 20px;
  align-items: flex-start;
  flex: 1 0 0;
  align-self: stretch;

  overflow-y: auto;
`

const StandardNight = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  flex: 1 0 0;

  .section {
    display: flex;
    width: 100;
    flex-direction: column;
    gap: 12px;
    width: 100%;

    .titleRow {
      display: flex;
      align-items: center;
      gap: 4px;
      align-self: stretch;

      > h5 {
        color: #ff8e2a;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 20px;
        margin: 0;
      }
    }

    .titleRow.gas > h5 {
      color: #10c1ee;
    }
  }

  > .titleRow {
    display: flex;
    padding: 10px 0px;
    align-items: center;
    gap: 4px;
    align-self: stretch;

    > svg {
      width: 18px;
      height: 18px;
    }

    > h5 {
      color: #3e3e3e;
      font-feature-settings: 'liga' off, 'clig' off;
      font-family: Nunito;
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      margin: 0;
    }
  }
`

const CustomContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  flex: 1 0 0;
  align-self: stretch;

  .section {
    display: flex;
    width: 100;
    flex-direction: column;
    gap: 12px;
    width: 100%;
  }

  .titleRow {
    display: flex;
    padding: 10px 0px;
    align-items: center;
    gap: 4px;
    align-self: stretch;

    > h5 {
      color: #ff8e2a;
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: 20px;
      margin: 0;
    }
  }

  .titleRow.gas > h5 {
    color: #10c1ee;
  }
`

const EnergyInputs = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`

const InputsGroup = styled(EnergyInputs)`
  gap: 12px;

  h4 {
    align-self: stretch;
    color: #1d1e22;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    margin: 0;
    text-transform: unset !important;
    display: flex;
    gap: 4px;
    align-items: center;
    justify-content: flex-start;
  }
`

const CustomInputsRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 18px;
  align-self: stretch;
`

const StyledSelect = styled(Select)`
  width: 100%;

  > div:first-child {
    height: 40px;
  }

  > div {
    padding: 10px;
    border: 1px solid #bababa;

    color: #3e3e3e;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px; /* 142.857% */

    > span {
      display: flex;
      align-items: center;
      gap: 8px;
      font-weight: 400;
    }
  }

  > div:last-child {
    > div {
      display: flex;
      align-items: center;
      gap: 8px;
    }
  }
`

const InputLabel = styled.label`
  height: 25px;
  align-self: stretch;
  color: #3e3e3e;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  text-transform: unset !important;
`

const WrapperSelect = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 0 0;
  width: 100%;
`

const InputsRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  row-gap: 12px;

  .iconInput {
    width: 100%;
    display: flex;
    align-items: flex-end;
    gap: 8px;

    > .icon {
      display: flex;
      width: 20px;
      padding: 12px 0px;
      justify-content: center;
      align-items: center;
    }
  }

  @media screen and (min-width: 600px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-end;

    .iconInput {
      gap: 0px;
    }
  }
`

const BtnsWrapper = styled.div`
  display: flex;
  padding: 16px;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  align-self: stretch;
  border-top: 1px solid #ececec;

  > div:first-child {
    width: 100%;
  }

  > button {
    width: 100%;
  }

  @media screen and (min-width: 600px) {
    > div:first-child {
      width: 140px;
    }

    > button {
      width: 140px;
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/EditDataModalV2/mobile.js